import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { TranslateService } from 'ng2-translate';
const json = require("json!./../../../resources/properties.json");

@Injectable()
export class MainService {

    private token: string;
    private _mainUrl = "/mainData";
    private serverURL: string;

    constructor(private _translateService: TranslateService, private http: Http) {
        this.getTokenService();
        this.serverURL = json.api_url;
    }

    getTokenService() {
        this.token = localStorage.getItem('token');
    }

    getLanguage() {
        return this._translateService.currentLang;
    }

    getUserStatus(): Promise<any> {

        let token = localStorage.getItem('token');
        let authHeader = new Headers({
            'Content-Type': 'application/x-www-form-urlencoded'
        });

        if (token != null && token != "") {

            authHeader.append('Authorization', 'Bearer ' + token);
            let options = new RequestOptions({ headers: authHeader, body: "" });
            return this.http.get(this.serverURL + '/loginData/userStatus', options).toPromise().then(res => {
                if (JSON.parse(res.text()).code == -1) {
                    return "guest";
                } else {
                    return JSON.parse(res.text());
                }
            }).catch(this.handleError);
        } else {
            return Promise.resolve({ role: "guest" });
        }

    }

    getUserLanguage() {

        let token = localStorage.getItem('token');
        let authHeader = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });

        if (token != null && token != "") {

            authHeader.append('Authorization', 'Bearer ' + token);
            let options = new RequestOptions({ headers: authHeader, body: "" });

            return this.http.get(this.serverURL + this._mainUrl + "/language", options).toPromise().then(res => {

                if (JSON.parse(res.text()).code == 1) {
                    return JSON.parse(res.text()).language;
                }

            }).catch(this.handleError);

        }

    }

    getUnreadMessages() {
        let token = localStorage.getItem('token');
        let authHeader = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });

        if (token != null && token != "") {

            authHeader.append('Authorization', 'Bearer ' + token);
            let options = new RequestOptions({ headers: authHeader, body: "" });

            return this.http.get(this.serverURL + this._mainUrl + "/messages", options).toPromise().then(res => {

                if (JSON.parse(res.text()).code == 1) {
                    return JSON.parse(res.text()).rows;
                } else {
                    return null;
                }

            }).catch(this.handleError);

        }
    }

    getUserName() {
        return localStorage.getItem("userName");
    }

    changeLanguage(lang: string) {
        this._translateService.setDefaultLang(lang);
        this._translateService.use(lang);
    }

    login(email: string, password: string) {

        let creds = "email=" + email + "&password=" + password;

        return this.http.post(this.serverURL + '/loginData', creds, { headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' }) }).map((res: any) => {
            let data = res.json();
            if (data.token !== undefined) {
                this.token = data.token;
                localStorage.setItem('token', this.token);
            }
            return data;
        });

    }

    verifyEmail(email: string) {
        let token = localStorage.getItem('token');
        let authHeader = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });

        authHeader.append('Authorization', 'Bearer ' + token);
        let options = new RequestOptions({ headers: authHeader, body: "" });

        return this.http.get(this.serverURL + "/usersData/existsEmail/" + email, options).toPromise().then(res => {

            if (JSON.parse(res.text()).code == 1) {
                return true;
            } else {
                return false;
            }

        }).catch(this.handleError);


    }

    sendEmailRecoverPassword(email: string) {

        var authHeader = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });

        return this.http.post(this.serverURL + "/loginData/forgetPassword", this.serializeObj({ email: email }), { headers: authHeader }).toPromise().then(result => {

            return JSON.parse(result.text()).code;

        }).catch(this.handleError);

    }

    changeUserPassword(encryptedEmail: string, password: string) {

        var authHeader = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });

        return this.http.post(this.serverURL + "/passwordData/changePassword", this.serializeObj({ encrypted_email: encryptedEmail, password: password }), { headers: authHeader }).toPromise().then(result => {

            if (JSON.parse(result.text()).code == 1) {
                return JSON.parse(result.text());
            } else {
                return null;
            }

        }).catch(this.handleError);

    }

    getElementsBySearchFilterValue(searchFilterValue: string) {
        let token = localStorage.getItem('token');
        let authHeader = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });

        authHeader.append('Authorization', 'Bearer ' + token);
        let options = new RequestOptions({ headers: authHeader, body: "" });
        return this.http.get(this.serverURL + this._mainUrl + "/search/" + searchFilterValue, options).toPromise().then(res => {
            if (JSON.parse(res.text()).code == 1) {
                return JSON.parse(res.text()).rows;
            } else {
                return null;
            }

        }).catch(this.handleError);

    }

    getElementsAuthenticatedBySearchFilterValue(searchFilterValue: string) {
        let token = localStorage.getItem('token');
        let authHeader = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });

        authHeader.append('Authorization', 'Bearer ' + token);
        let options = new RequestOptions({ headers: authHeader, body: "" });
        return this.http.get(this.serverURL + this._mainUrl + "/search/authenticated/" + searchFilterValue, options).toPromise().then(res => {
            if (JSON.parse(res.text()).code == 1) {
                return JSON.parse(res.text()).rows;
            } else {
                return null;
            }

        }).catch(this.handleError);

    }

    private handleError(error: any) {
        let errMsg = (error.message) ? error.message : error.status ? `${error.status} - ${error.statusText}` : 'Server error';
        console.error(errMsg);
        return Observable.throw(errMsg);
    }

    private serializeObj(obj: any) {
        var result: any[] = [];
        for (var property in obj) {
            result.push(encodeURIComponent(property) + "=" + encodeURIComponent(obj[property]));
        }
        return result.join("&");
    }

}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/main/main.service.ts
 **/